<template>
  <div class="waiter-area">
    <div class="row justify-content-center">
      <div class="col-2 p-0" v-for="(waiter, index) in waiters" :key="index">
        <div class="card-item">
          <!-- <Card /> -->

          <!-- Use above card component for integration. 
          Below lines are used for a demo purpose-->

          <!-- Demo Code -->
          <div
            id="summary"
            :class="{
              allocated: waiter.selected,
            }"
            @click="SelectWaiter(waiter)"
          >
            <strong>{{ waiter.name }}</strong>
            <!-- <em>Table1</em> -->
            <!-- <small>Pimpilikka pilaappi</small> -->
          </div>
          <!-- Demo Code -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/plugins/axios';
import('./style.css');

export default {
  name: 'WaiterList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedCustomer: {
      type: Object,
      default: {},
    },
    selectedWaiter: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    waiters: [],
  }),
  watch: {
    visible: function(value) {
      if (!value) {
        this.selected = 0;
      }
    },
  },

  created: function() {
    this.GetAllWaiters();
  },
  methods: {
    async GetAllWaiters() {
      let url = 'hms/web/waiters';
      axios
        .get(url)
        .then((res) => {
          console.log('Placesss', res);
          this.waiters = res.data.map((p) => {
            if (p.id == this.selectedWaiter.id) {
              p.selected = true;
            } else {
              p.selected = false;
            }

            (p.id = p.id), (p.name = p.name);
            return p;
          });

          this.loaded = true;
        })
        .catch((err) => {});
    },
    SelectWaiter(waiter) {
      waiter.selected = true;
      this.$emit('SelectWaiter', waiter);
    },
  },
};
</script>
